// Groups activity entries into Today / Yesterday / dated buckets, in
// first-seen order. Extracted because ActivityLogDrawer and
// ActivityLogSection had a byte-identical copy of this. The dated label
// goes through the shared formatDayMonthYear so it matches the brand
// short-date format used everywhere else (no locale "Sept"/"June" drift).

import { formatDayMonthYearLocal } from "../../../utils/formatShortDate";
import type { ActivityEntry } from "../../../types";

export interface ActivityDayGroup {
  dayLabel: string;
  entries: ActivityEntry[];
}

export function groupActivityByDay(
  entries: ActivityEntry[],
): ActivityDayGroup[] {
  const today = new Date();
  const todayStr = today.toDateString();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const yesterdayStr = yesterday.toDateString();

  const groups = new Map<string, ActivityEntry[]>();
  for (const entry of entries) {
    const key = new Date(entry.occurredAt).toDateString();
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key)!.push(entry);
  }

  return Array.from(groups.entries()).map(([key, dayEntries]) => {
    let label: string;
    if (key === todayStr) {
      label = "Today";
    } else if (key === yesterdayStr) {
      label = "Yesterday";
    } else {
      // `key` is a LOCAL toDateString(); format by its local calendar
      // day so the label matches the bucket.
      label = formatDayMonthYearLocal(new Date(key));
    }
    return { dayLabel: label, entries: dayEntries };
  });
}
